(function () {
	'use strict';

	/**
	 * @ngdoc type
	 * @name mx.shell.WizardPage
	 * @module mx.shell
	 *
	 * @description
	 * Type that contains ultimate information about wizard page.
	 * A constructor accepts `options` parameter that may contain fields to extend corresponding properties. Created like:
	 * ```javascript
	 var options = {
		id: 'wiz_1',
		title: 'Single wizard page',
		buttons: {
			finish: new MxWizardButton('Finish wizard', true),
			cancel: new MxWizardButton('Cancel wizard', true),
			next: new MxWizardButton('Next page', false),
			back: new MxWizardButton('Previous page', false)
		},
		templateUrl: 'wizard-page-1.html',
		controller: 'firstPageController',
		wizardStep: 'Step 1. And final.'
	 };

	 var page = new MxWizardPage(options);
	 * ```
	 * @property {string} id - Gets or sets wizard's page identifier
	 * @property {string} title - Gets or sets wizard's page title.<br>Default value is `Untitled`
	 * @property {mx.shell.WizardButton[]} buttons - Gets or sets wizard's page buttons.
	 * There are should be buttons with names 'back', 'next', 'cancel', 'finish'
	 * @property {string | function} controller - Controller function that should be associated with a newly created
	 * scope or the name of a registered controller if passed as a string
	 * @property {string} templateUrl - Gets or sets path to html template
	 * @property {string} template - Gets or sets html template
	 * @property {string} header - Gets or sets page's header
	 * @property {boolean} toBeSkipped - Determine if this page should be skipped.<br>Default value is `false`
	 * @property {mx.shell.View} view - Gets page's view.<br>`readonly`
	 * @property {string} wizardStepId - Gets or sets wizard step identifier this page is related to.<br>Default value is `base`
	 * @property {int} orderNum - Gets or sets page's order in wizard if page order is not handled by page controller.<br>
	 * Default value is `0`.
	 * @property {object} sharedWizardData - Gets or sets an object that holds information, already collected by wizard.
	 * It is set by wizard usually once on page enter and should be handled in view controller.
	 */
	angular.module('mx.shell').factory('mx.shell.WizardPage', [
		'mx.shell.WizardView',
		function wizardPageFactory(View) {
			function WizardPage(options) {
				var that = this;

				Object.defineProperty(that, 'id', { writable: true });
				Object.defineProperty(that, 'widgetId', { writable: true });
				Object.defineProperty(that, 'title', {
					writable: true,
					value: 'Untitled',
				});
				Object.defineProperty(that, 'key', {
					writable: true,
					value: 'Undefined',
				});
				Object.defineProperty(that, 'buttons', { writable: true });
				Object.defineProperty(that, 'controller', {
					writable: true,
					value: {},
				});
				Object.defineProperty(that, 'templateUrl', { writable: true });
				Object.defineProperty(that, 'template', { writable: true });
				Object.defineProperty(that, 'wizardStepId', {
					writable: true,
					value: 'base',
				});
				Object.defineProperty(that, 'orderNum', {
					writable: true,
					value: 0,
				});
				Object.defineProperty(that, 'header', {
					writable: true,
					value: '',
				});
				Object.defineProperty(that, 'toBeSkipped', {
					writable: true,
					value: false,
				});

				var pageView;

				Object.defineProperty(that, 'view', {
					get: function () {
						if (!pageView) {
							const template = that.template?.replace('>', ' mx-service-context="vm.dataModel" mx-service-context-info="vm.serviceContextInfo">');
							pageView = new View({
								displayName: that.title,
								controller: that.controller,
								templateUrl: that.templateUrl,
								template: template,
								locals: {
									sharedWizardData: that.sharedWizardData,
									dataModel: that.dataModel,
									loadSource: that.loadSource,
									serviceContextInfo: {
										widgetId: that.widgetId,
										viewName: that.key,
									},
								},
							});
						}

						return pageView;
					},
				});

				var sharedData;

				Object.defineProperty(that, 'sharedWizardData', {
					get: function () {
						return sharedData;
					},
					set: function (value) {
						sharedData = value;
					},
				});

				that = angular.extend(that, options);

				that.buttons = that.buttons || [];
			}

			return WizardPage;
		},
	]);
})();
